// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"SignUpStyle_title_wrapper__3bKj_","container":"SignUpStyle_container__16VPA","content":"SignUpStyle_content__NHlWh","checkBox":"SignUpStyle_checkBox__1Qk2i"};